<template>
	<Row>
		<Container>
			<div class="gradient-container">
				<h1 class="content-title">{{ title }}</h1>
				<p class="text-white text-[20px] text-center mx-auto">{{ paragraph }}</p>
			</div>
		</Container>
	</Row>
</template>
<script>
export default {
	props: {
		title: String,
		paragraph: String
	}
};
</script>
<style lang="scss" scoped>
.gradient-container {
	position: relative;
	width: 100%;
	height: 100%;
	background: rgb(15, 20, 36);
	background-clip: padding-box;
	border: solid 2px transparent;
	border-radius: 1em;
	padding: 64px;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: -1;
		margin: -2px;
		border-radius: inherit;
		background: linear-gradient(to right, #50b5ff, #be55ff);
	}

	.content-title {
		font-family: Open Sauce Sans;
		font-size: 54px;
		font-weight: 500;
		line-height: 59px;
		letter-spacing: -0.02em;
		text-align: center;
		margin-bottom: 24px;
		background: linear-gradient(
			90deg,
			rgb(255, 255, 255) 25%,
			rgb(67, 131, 255) 60%,
			rgb(196, 100, 255) 70%,
			rgb(255, 255, 255) 95%
		);
		-webkit-background-clip: text;
		color: transparent;
		background-clip: text;
	}
}
</style>
